/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DownloadsRouteImport } from './routes/downloads'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout.success'
import { Route as CheckoutPlanIdRouteImport } from './routes/checkout.$planId'

const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadsRoute = DownloadsRouteImport.update({
  id: '/downloads',
  path: '/downloads',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout/success',
  path: '/checkout/success',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutPlanIdRoute = CheckoutPlanIdRouteImport.update({
  id: '/checkout/$planId',
  path: '/checkout/$planId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/downloads': typeof DownloadsRoute
  '/faq': typeof FaqRoute
  '/checkout/$planId': typeof CheckoutPlanIdRoute
  '/checkout/success': typeof CheckoutSuccessRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/downloads': typeof DownloadsRoute
  '/faq': typeof FaqRoute
  '/checkout/$planId': typeof CheckoutPlanIdRoute
  '/checkout/success': typeof CheckoutSuccessRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/downloads': typeof DownloadsRoute
  '/faq': typeof FaqRoute
  '/checkout/$planId': typeof CheckoutPlanIdRoute
  '/checkout/success': typeof CheckoutSuccessRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/downloads'
    | '/faq'
    | '/checkout/$planId'
    | '/checkout/success'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/downloads' | '/faq' | '/checkout/$planId' | '/checkout/success'
  id:
    | '__root__'
    | '/'
    | '/downloads'
    | '/faq'
    | '/checkout/$planId'
    | '/checkout/success'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DownloadsRoute: typeof DownloadsRoute
  FaqRoute: typeof FaqRoute
  CheckoutPlanIdRoute: typeof CheckoutPlanIdRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/downloads': {
      id: '/downloads'
      path: '/downloads'
      fullPath: '/downloads'
      preLoaderRoute: typeof DownloadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/checkout/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/$planId': {
      id: '/checkout/$planId'
      path: '/checkout/$planId'
      fullPath: '/checkout/$planId'
      preLoaderRoute: typeof CheckoutPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DownloadsRoute: DownloadsRoute,
  FaqRoute: FaqRoute,
  CheckoutPlanIdRoute: CheckoutPlanIdRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
